import { render, staticRenderFns } from "./GenreChips.vue?vue&type=template&id=6ae4ccfc&scoped=true&"
import script from "./GenreChips.vue?vue&type=script&lang=js&"
export * from "./GenreChips.vue?vue&type=script&lang=js&"
import style0 from "./GenreChips.vue?vue&type=style&index=0&id=6ae4ccfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae4ccfc",
  null
  
)

export default component.exports